import _ from 'lodash';
import { OrderedMap, fromJS } from 'immutable';
import * as dishConstants from '../DishContainer/constants';
import * as ppsiConstants from '../PpsiContainer/constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    ingredientEntries: OrderedMap()
  });

function mergeIngredientEntries(state, entries = []) {
  const ingredientEntriesState = state.get('ingredientEntries');
  if (!entries || entries.length === 0) {
    return ingredientEntriesState;
  }
  const ingredientEntriesToMerge = _.isArray(entries) ? entries : [entries];
  return ingredientEntriesState.merge(
    ingredientEntriesToMerge.reduce(
      (map, item) => map.set(item.id, fromJS(item)),
      OrderedMap()
    )
  );
}

function mergeForDish(state, dish = {}) {
  const { ingredientEntryList } = dish;
  return mergeIngredientEntries(state, ingredientEntryList);
}

function mergeForDishes(state, dishes = []) {
  const ingredientEntries = dishes.reduce(
    (entries, dish) => entries.concat(dish.ingredientEntryList),
    []
  );
  return mergeIngredientEntries(state, ingredientEntries);
}

/**
 * Get ingredient entries for a PPSI. Both entries for in progress and published
 * is returned.
 *
 * @param ppsi
 * @returns {*}
 */
function getIngredientEntriesForPpsi(ppsi) {
  const inProgressIngredientEntries = _.get(
    ppsi,
    'inProgressPpsiEnrichmentData.referencedIFoodData.referencedIngredientEntities',
    []
  );
  const publishedIngredientEntries = _.get(
    ppsi,
    'publishedPpsiEnrichmentData.referencedIFoodData.referencedIngredientEntities',
    []
  );
  return inProgressIngredientEntries.concat(publishedIngredientEntries);
}

function mergeForPpsi(state, ppsi) {
  const ingredientEntries = getIngredientEntriesForPpsi(ppsi);
  return mergeIngredientEntries(state, ingredientEntries);
}

function mergeForPpsis(state, ppsis) {
  const ingredientEntries = ppsis.reduce((entries, ppsi) => {
    const ppsiIngredientEntries = getIngredientEntriesForPpsi(ppsi);
    return entries.concat(ppsiIngredientEntries);
  }, []);
  return mergeIngredientEntries(state, ingredientEntries);
}

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();
    case dishConstants.FETCH_DISH_DONE:
      return state.set('ingredientEntries', mergeForDish(state, payload));
    case dishConstants.FETCH_DISHES_DONE:
      return state.set('ingredientEntries', mergeForDishes(state, payload));
    case ppsiConstants.FETCH_PPSI_DONE:
      return state.set('ingredientEntries', mergeForPpsi(state, payload));
    case ppsiConstants.FETCH_PPSIS_DONE:
      return state.set('ingredientEntries', mergeForPpsis(state, payload));
    case ppsiConstants.IMPORT_IFOOD_UPDATE_PPSI_DONE:
      return state.set('ingredientEntries', mergeForPpsi(state, payload));
    default:
      return state;
  }
}
